import styled from '@emotion/styled';

import { Table } from '@/design-system';

const FOCUS_RING_WIDTH = 2;

// A mouse click never fires `:focus-visible`, so the design-system row focus ring drops the
// moment the chart selection is made. The ring is repainted as `::after` because an `outline`
// renders below the pinned Actions cell, which is sticky at z-index 2 with its own background.
export const SelectableTable = styled(Table)(({ theme }) => ({
  '& [role="row"]:has([data-selected="true"])': {
    position: 'relative',

    '&::after': {
      content: '""',
      position: 'absolute',
      inset: 0,
      zIndex: 3,
      border: `${FOCUS_RING_WIDTH}px solid ${theme.colors.border.focus}`,
      borderRadius: 'inherit',
      pointerEvents: 'none',
    },
  },
})) as typeof Table;

export const AssetNameCell = styled('div')(({ theme }) => ({
  display: 'flex',
  minWidth: 0,
  alignItems: 'center',
  gap: theme.spacing[8],
}));

export const SelectionIcon = styled('span', {
  shouldForwardProp: (prop) => prop !== '$active',
})<{ $active: boolean }>(({ theme, $active }) => ({
  display: 'inline-flex',
  flexShrink: 0,
  color: $active ? theme.colors.brand.text : theme.colors.icon.secondary,

  svg: {
    width: 16,
    height: 16,
  },
}));

export const RowActions = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: theme.spacing[8],
}));

export const MobileRowActions = styled(RowActions)(({ theme }) => ({
  justifyContent: 'center',
  flexWrap: 'wrap',
  padding: theme.spacing[8],
}));
